import { render } from "./PageNumber2.vue?vue&type=template&id=3200b237&scoped=true"
import script from "./PageNumber2.vue?vue&type=script&lang=js"
export * from "./PageNumber2.vue?vue&type=script&lang=js"

import "./PageNumber2.vue?vue&type=style&index=0&id=3200b237&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3200b237"]])

export default __exports__